import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'main',
      component: Home,
      redirect: '/welcome',
      children: [
        {
          path: 'chat',
          name: 'chat',
          component: () => import('@/views/chat')
        },
        {
          path: 'work',
          name: 'work',
          component: () => import('@/views/work')
        },
        {
          path: 'sub',
          name: 'sub',
          component: () => import('@/views/sub')
        },
        {
          path: 'redraw',
          name: 'redraw',
          component: () => import('@/views/redraw')
        },
        {
          path: 'scriptBuild',
          name: 'scriptBuild',
          component: () => import('@/views/scriptBuild')
        },
        {
          path: 'styleprev',
          name: 'styleprev',
          component: () => import('@/views/styleprev')
        },
        {
          path: 'aimatting',
          name: 'aimatting',
          component: () => import('@/views/aimatting')
        },
        {
          path: 'hdzoom',
          name: 'hdzoom',
          component: () => import('@/views/hdzoom')
        },

        {
          path: 'colorfit',
          name: 'colorfit',
          component: () => import('@/views/colorfit')
        },
        {
          path: 'faceChange',
          name: 'faceChange',
          component: () => import('@/views/facechange')
        },
        {
          path: 'upperbody',
          name: 'upperbody',
          component: () => import('@/views/upperbody')
        },
        {
          path: 'materialupper',
          name: 'materialupper',
          component: () => import('@/views/materialupper')
        },



        {
          path: 'upperbodyFix',
          name: 'upperbodyFix',
          component: () => import('@/views/upperbodyFix')
        },
        {
          path: 'changebackground',
          name: 'changebackground',
          component: () => import('@/views/changebackground')
        },



        {
          path: 'fabricPreview',
          name: 'fabricPreview',
          component: () => import('@/views/fabricPreview')
        },
        {
          path: 'areaInpaint',
          name: 'areaInpaint',
          component: () => import('@/views/areaInpaint')
        },
        {
          path: 'aichange',
          name: 'aichange',
          component: () => import('@/views/aichange')
        },

        {
          path: 'draw',
          name: 'draw',
          component: () => import('@/views/draw')
        },
        {
          path: 'mypics',
          name: 'mypics',
          component: () => import('@/views/mypics')
        },
        {
          path: 'build',
          name: 'build',
          component: () => import('@/views/build')
        },
        {
          path: 'picbuild',
          name: 'picbuild',
          component: () => import('@/views/picbuild')
        },

        {
          path: 'svg',
          name: 'svg',
          component: () => import('@/views/svg')
        },


        {
          path: 'pic2text',
          name: 'pic2text',
          component: () => import('@/views/pic2text')
        },

        {
          path: 'mypro',
          name: 'mypro',
          component: () => import('@/views/mypro')
        },
        {
          path: 'mywork',
          name: 'mywork',
          component: () => import('@/views/mywork')
        },
        {
          path: 'welcome',
          name: 'welcome',
          component: () => import('@/views/welcome')
        },
        {
          path: 'recolor',
          name: 'recolor',
          component: () => import('@/views/recolor')
        },
        {
          path: '/caseSquare',
          name: 'caseSquare',
          component: () => import('@/views/caseSquare')
        }
      ]
    },
    {
      path: '/my',
      name: 'my',
      component: () => import('@/views/user/my')
    },

    {
      path: '/catchRegion',
      name: 'catchRegion',
      component: () => import('@/views/catchRegion')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js